import React from 'react';

const VisaLogo = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_11481_16124"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path
          d="M17.5 0H2.5C1.11929 0 0 1.11929 0 2.5V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5V2.5C20 1.11929 18.8807 0 17.5 0Z"
          fill="currentColor"
        />
      </mask>
      <g mask="url(#mask0_11481_16124)">
        <path d="M0 0H20V20H0V0Z" fill="#1434CB" />
        <path
          d="M12.1346 5.55469L9.82458 11.5225L8.86237 6.44358C8.73348 5.87246 8.28458 5.55469 7.83569 5.55469H4.50903L4.44458 5.80912C5.21458 5.99912 5.79348 6.18913 6.30681 6.44358C6.46681 6.52358 6.60014 6.6658 6.68125 7.26913L8.34903 14.4436H10.7224L14.4446 5.55469H12.1346Z"
          fill="url(#paint0_linear_11481_16124)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_11481_16124"
          x1="85.2146"
          y1="120.559"
          x2="86.9458"
          y2="51.0902"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default VisaLogo;
